var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGuvenliOtel = function SvgGuvenliOtel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 1.5,
    y: 1.5,
    fill: "#00B7C8",
    stroke: "#00B7C8",
    strokeWidth: 3,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 42,
    x: 3,
    y: 13,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B7C8",
    d: "m24.276 21.464 2.443 2.611 6.066-6.485a1.819 1.819 0 0 1 1.351-.59c1.666.02 2.488 2.173 1.309 3.433l-7.463 7.98a1.8 1.8 0 0 1-2.66 0L21.55 24.38c-.72-.769-.736-2.01-.038-2.802l.065-.073a1.798 1.798 0 0 1 2.698-.042"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#00B7C8",
    fontFamily: "Montserrat, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.23,
    y: 41
  }, "G\xDCVENL\u0130")), /*#__PURE__*/React.createElement("text", {
    fill: "#00B7C8",
    fontFamily: "Montserrat, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.5,
    y: 52
  }, "TUR\u0130ZM")), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Montserrat, sans-serif",
    fontSize: 8,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15.885,
    y: 10
  }, "ONAYLI")))));
};

export default SvgGuvenliOtel;